import $ from 'jquery';
import 'scroll-depth';

import { trackEvent } from '@99designs/common/utils/platform';

export default class ScrollDepthTracking {
    constructor(pageName = '') {
        this.pageName = pageName;

        this.setup();
    }

    setup() {
        $.scrollDepth({
            percentage: true,
            userTiming: false,
            pixelDepth: false,
            nonInteraction: false,
            eventHandler: data => {
                trackEvent(`Scrolled ${this.pageName} To ${data.eventLabel}`, {
                    page_height: $(document).height(),
                });
            },
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/utils/ScrollDepthTracking.js